
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wix-partner/[slug]",
      function () {
        return require("private-next-pages/wix-partner/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wix-partner/[slug]"])
      });
    }
  